import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link } from 'react-router-dom';


export default class CourseList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loader: true

        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getCourse = this.getCourse.bind(this);
    }
    // imam pristup id ankete proslijedjen preko location(link)
    componentDidMount() {
        this.getCourse();
        localStorage.removeItem('selectedAssistants');
        localStorage.removeItem('selectedProfessors');
    }
    getCourse() {
        let obj = { id: JSON.parse(localStorage.getItem('poll')).pollId };
        axios.post('/students/current-courses/questionnaires/', obj)
            .then(res => {
                const courses = res.data;
                // console.log('predmeti: ', courses);
                this.setState({ data: courses, loader: false });
            })
            .catch(err => {
                this.setState({ loader: false });
                console.log('Failed to fetch courses.');
            });
    }


    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.data;
    }


    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        return (

            <div>
                {this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader size="medium" active /></div> :
                    this.getDataToRender().length === 0 ? <div><FormattedMessage id="poll.notEnrolledCurrentSemesterMessage" /></div> : <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell >
                                <FormattedMessage id="common.courseName" />
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                <FormattedMessage id="common.courseType" />
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                <FormattedMessage id="poll.access" />
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                               <FormattedMessage id="poll.status" />
                                </Table.HeaderCell>


                                <Table.HeaderCell colSpan="1" ></Table.HeaderCell>


                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.getDataToRender().map((el, index) =>
                                (<Table.Row
                                    key={index}
                                    positive={el.accessed}
                                    negative={!el.accessStatus}
                                >
                                    <Table.Cell verticalAlign="middle">
                                        {el.courseDTO.courseName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.courseDTO.mandatory ? <FormattedMessage id="common.mandatory" /> : <FormattedMessage id="common.optional" />}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        <Icon name={el.accessStatus ? 'checkmark' : 'close'} />
                                        {el.accessStatus ? <FormattedMessage id="poll.accessGranted" /> : <FormattedMessage id="poll.accessProhibited" />}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        <Icon name={el.accessed ? 'checkmark' : 'close'} />
                                        {el.accessed ? <FormattedMessage id="poll.evaluated" /> : <FormattedMessage id="poll.notEvaluated" />}
                                    </Table.Cell>

                                    <Table.Cell verticalAlign="middle" textAlign="center" colSpan="1">
                                        {/* link */}

                                        <Button
                                            onClick={() => {
                                            // console.log('izvrsava se opet');
                                                localStorage.setItem('courseId', el.courseDTO.courseImplementationId);
                                                localStorage.setItem('courseName', el.courseDTO.courseName);
                                            }}

                                            basic="true"
                                            color="blue"
                                            size="small"
                                            disabled={el.accessed || !el.accessStatus}
                                        >
                                            <Link to={{
                                                pathname: '/anketa/predmeti/ocjenjivanje',
                                                state: {
                                                    pollId: this.props.pollId,
                                                    courseId: el.courseDTO.courseImplementationId
                                                }

                                            }}
                                            > <FormattedMessage id="poll.evaluateButton" /></Link>
                                        </Button>


                                    </Table.Cell>
                                </Table.Row>))}
                        </Table.Body>

                    </Table>}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/StudentPoll/CourseList.js